export const getFileExtension = fullFileName => {
  const lastDotIndex = fullFileName.lastIndexOf('.');
  const result = {
    extension: '',
    name: fullFileName
  };
  if (lastDotIndex !== -1) {
    result.extension = fullFileName.slice(lastDotIndex);
    result.name = fullFileName.slice(0, lastDotIndex);
  }
  return result;
};